import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { Conf } from '../conf';


@Injectable()
export class ApiService {
  public url: string;
  protected headers: HttpHeaders = new HttpHeaders();
  protected headersPrepared = false;

  public constructor(
    private http: HttpClient
  ) {

    this.url = environment.api.url;

    for (const header of Conf.api.headers) {
      this.headers = this.headers.set(header.header, header.value);
    }
  }

  public async get(route: string): Promise<HttpResponse<any> | any> {
    const res = await this.http.get(this.url + route, {headers: this.headers}).toPromise() as any;
    return res;
  }

  public async post(route: string, data?: any): Promise<HttpResponse<any> | any> {
    const res = await this.http.post(this.url + route, JSON.stringify(data), {headers: this.headers}).toPromise() as any;
    return res;
  }

  public async put(route: string, data?: any): Promise<HttpResponse<any> | any> {
    const res = await this.http.put(this.url + route, JSON.stringify(data), {headers: this.headers}).toPromise() as any;
    return res;
  }

  public async delete(route: string): Promise<HttpResponse<any> | any> {
    const res = await this.http.delete(this.url + route, {headers: this.headers}).toPromise() as any;
    return res;
  }

}
